export default __webpack_public_path__ + "static/finance-fraud-prevention-img-1-26ac2c10a3bd5f58eaa48a42c536718c.svg";